var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[(_vm.$IsLogged)?_c('UploadFotos'):_vm._e(),_c('v-container',{staticClass:"main-content"},[(!_vm.$IsLogged)?_c('router-view'):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }